import { Heading as BaseHeading } from '@chakra-ui/core'

export const Header = ({ children, ...props }) => (
    <BaseHeading color="var(--text-main)" {...props}>
        {children}
    </BaseHeading>
)
